module.exports = __webpack_public_path__ + "img/borde1.ad04e85a.svg";